import { TFunction } from 'i18next';
import { apiClientWithoutHandler } from 'src/js/api';
import { APIPath } from 'src/js/api/route-path-index';
import { createWatchStore, updateWatchStore } from 'src/js/store/use-watch';
import { AllStorageModels, GetStoragesResponse } from './storage-model';

const storageStore: AllStorageModels = {};
createWatchStore(storageStore);
export { storageStore };

export const fetchStorage = (_t: TFunction) => {
  return apiClientWithoutHandler.genericController.get<GetStoragesResponse>(APIPath.storage.all).then((res) => {
    if (res.ok) {
      const response = res.data;
      if (response) {
        updateWatchStore(storageStore, response.data);
      }
    }
    return res;
  });
};
